import { CradleCommands, ScheduledRings } from './../constants/constants';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../services/data.service';
import {
  Day,
  OccurenceTypes,
  RingPattern,
  RingPatterns,
  ScheduledRing,
} from '../constants/constants';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Utils } from '../constants/utils';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { CradleService } from '../services/cradle.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import cloneDeep  from 'lodash-es/cloneDeep';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { TimeFormatPipe } from '../services/time-format.pipe';
import { RouterModule } from '@angular/router';
import { environment } from '../../environment/environment';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
@Component({
    selector: 'app-schedule',
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatTableModule,
        FormsModule,
        MatSelectModule,
        MatInputModule,
        MatDialogModule,
        MatFormFieldModule,
        NgxMatTimepickerModule,
        MatSlideToggleModule,
        TimeFormatPipe,
        RouterModule
    ],
    templateUrl: './schedule.component.html',
    styleUrl: './schedule.component.scss'
})
export class ScheduleComponent implements OnInit {
  ringPatterns: RingPatterns;
  schedulesGettingEdited: ScheduledRings = {};
  ringPatternArr: RingPattern[];
  Day = Day;
  OccurenceTypes = OccurenceTypes;
  exitingSchIds: string[] = [];
  scheduledRings: ScheduledRing[] = [];
  scheduledTblColumns: string[] = [
    'id',
    'occurs',
    'time',
    'ringPattern',
    'actions',
  ];
  isEditing: boolean = false;
  isController = environment.isController;
  dismissLoaderTimout:any;

  constructor(
    private dataService: DataService,
    private matDialog: MatDialog,
    private cradleService: CradleService,
    private snackBar: MatSnackBar
  ) {}
  ngOnInit() {
    this.dataService.scheduledRings.subscribe((schRins) => {
      if(schRins){
        this.scheduledRings = schRins;
        this.exitingSchIds = schRins.map((s) => s.id);
        this.dismissLoader();
      }
    });
    this.dataService.ringPatterns.subscribe((r) => {
      if(r){
        this.ringPatterns = r;
        this.ringPatternArr = Utils.dictToList(r);
      }
    });
    this.cradleService.dispatchCommand(CradleCommands.GET_SCHEDULED_RINGS);
    this.cradleService.dispatchCommand(CradleCommands.GET_RING_PATTERNS);
  }

  updateScheduledRing(scheduledRing: ScheduledRing) {
    if (scheduledRing.isFirstEdit) {
      const duplicateId = this.exitingSchIds.includes(scheduledRing.id);
      if (duplicateId) {
        this.snackBar.open(
          `There is already another schedule with same id ${scheduledRing.id}. Please select another ID for the new schedule`,
          'Ok'
        );
        return;
      }
    }
    if (!scheduledRing.id) {
      this.snackBar.open(
        'Please enter a valid ID for schedule ' + scheduledRing.id, 'Ok'
      );
      return;
    }
    if (
      !(
        scheduledRing.occurs == OccurenceTypes.DAILY ||
        scheduledRing.occurs == OccurenceTypes.SELECTED_DAYS
      )
    ) {
      this.snackBar.open(
        'Please enter valid occurence type for schedule ' + scheduledRing.id, 'Ok'
      );
      return;
    }
    const [hh,mm] = scheduledRing?.time?.split(':');
    if (
      !( scheduledRing?.time &&
        Number(hh) >= 0 &&
        Number(hh) < 24 &&
        Number(mm) >= 0 &&
        Number(mm) < 60
      )
    ) {
      this.snackBar.open(
        'Please enter valid time for the schedule ' + scheduledRing.id, 'Ok'
      );
      return;
    }
    if (!(this.ringPatterns && this.ringPatterns[scheduledRing.pattern])) {
      this.snackBar.open(
        'Please select valid pattern to ring for the schedule ' +
          scheduledRing.id, 'Ok'
      );
      return;
    }

    scheduledRing.isEditing = false;
    scheduledRing.isFirstEdit = false;
    delete scheduledRing.isEditing;
    delete scheduledRing.isFirstEdit;
    console.log(scheduledRing);
    this.cradleService.dispatchCommand(
      CradleCommands.UPDATE_SCHEDULED_RING,
      scheduledRing
    );
    this.showLoaderWithTimout();
  }

  deleteSchedule(schedule: ScheduledRing) {
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
      data: {
        msg: `Are you sure you want to remove schedule ${
          schedule.id
        } which rings ${
          schedule.occurs == OccurenceTypes.DAILY
            ? ' Daily'
            : 'on every' + schedule.days.join(', ')
        }?`,
        title: 'Confirm Delete',
        confirmLabel: 'Delete',
      },
    });
    dialogRef.afterClosed().subscribe((deleteConfirmed) => {
      if (deleteConfirmed) {
        this.cradleService.dispatchCommand(
          CradleCommands.DELETE_SCHEDULED_RING,
          schedule.id
        );
        this.showLoaderWithTimout();
      }
    });
  }

  showLoaderWithTimout(){
    this.dataService.isLoading.next(true);
    this.dismissLoaderTimout = setTimeout(()=>{
      if(this.dataService.isLoading.value){
        this.dataService.isLoading.next(false);
        this.snackBar.open('Request timed out', 'Ok');
        this.cradleService.dispatchCommand(CradleCommands.GET_SCHEDULED_RINGS);
      }
    },5000);
  }

  dismissLoader(){
    this.dataService.isLoading.next(false);
    clearTimeout(this.dismissLoaderTimout);
  }

  startEditing(schedule:ScheduledRing){
    this.schedulesGettingEdited[schedule.id] = cloneDeep(schedule);
    schedule.isEditing = true;
  }

  cancelEditing(schedule: ScheduledRing){
    if(this.schedulesGettingEdited[schedule.id]){
      const pIdx = this.scheduledRings.findIndex(s=>s.id==schedule.id);
      const uneditedSchedule = this.schedulesGettingEdited[schedule.id];
      uneditedSchedule.isEditing = false;
      this.scheduledRings[pIdx] = uneditedSchedule;
    } else {
      const pIdx = this.scheduledRings.findIndex(s=>s.id==schedule.id);
      this.scheduledRings.splice(pIdx,1);
    }
    this.scheduledRings = [...this.scheduledRings];
  }
  addNewSchedule() {
    const newSchedule = new ScheduledRing();
    const existingIds = this.scheduledRings.map(s=>s.id);
    let newId = "1";
    while(existingIds.includes(newId)){
      newId = String(Number(newId)+1);
    }
    newSchedule.id =newId
    this.scheduledRings = [newSchedule, ...this.scheduledRings];
  }
  openFromIcon(timepicker: { open: () => void }){
    timepicker.open();
  }

  onDisableChange(schedule: ScheduledRing, event: MatSlideToggleChange){
    schedule.disabled = event.checked
    this.updateScheduledRing(schedule);
  }
}
